import Vue from 'vue'
import { mapActions, mapGetters  } from 'vuex'


Vue.mixin({
  
  methods: {
    ...mapActions([
        "updateLoader",
        "updateRol",
        "updateUserInfo"
    ]),
    ...mapGetters([
        "getLoader",
        "getRol",
        "getUserInfo"
    ]),
  }
  
});



// WEBPACK FOOTER //
// ./src/vue/mixins.js